import Link from "components/ExtendLink";
import moment from "moment";
import React, { useState } from "react";
import BootstrapTable from "react-bootstrap-table-next";
import filterFactory, { textFilter } from "react-bootstrap-table2-filter";
import doctorImage from "../../../../files/doctor.png";
import staffImage from "../../../../files/staff.png";
import LottieLoader from '../../../../components/LottieLoader';
import lottieEmptyFile from '../../../../files/animation/empty_new.json';
import lottieLoaderFile from '../../../../files/animation/loading.json';
import Swal from 'sweetalert2';
import { getFileIconClass } from "../../../../constants/general.constant";
import {
  formatAppointmentReminderBadge,
  isAppointmentOverdue,
} from "../../../../helpers/appointmentReminderHelper";
const _ = require("lodash");

function fullname(cell, row) {
  let imageUser;
  let isPublic;
  if (cell && row.createdBy) {
    if (!row.createdBy.isStaff) {
      imageUser = (
        <p>
          <img src={row.createdBy.profileImage ? process.env.REACT_APP_VIDEO_CALL_REQUEST + "/" + row.createdBy.profileImage : doctorImage} className="mr-2" alt="image" />
          {row.createdBy.fname} {row.createdBy.lname}
        </p>
      );
    } else {
      imageUser = (
        <p>
          <img src={row.createdBy.profileImage ? process.env.REACT_APP_VIDEO_CALL_REQUEST + "/" + row.createdBy.profileImage : staffImage} className="mr-2" alt="image" />
          {row.createdBy.fname} {row.createdBy.lname}
        </p>
      );
    }
  } else {
    imageUser = "";
  }
  if (row.isPublic) {
    isPublic = (
      <div className="ml-5">
        <span class="badge badge-pill badge-warning">Public Note</span>
      </div>
    );
  }
  return (
    <div>
      {imageUser} {isPublic}
    </div>
  );
}
function device(cell, row, index, formatExtraData) {
  // Handle null/undefined cell
  if (!cell) {
    return (
      <div className="text-center">
        <span className="text-muted">-</span>
      </div>
    );
  }
  const displayName = /(Bluetooth|Cellular)/i.test(cell.name) && row?.onBoarding?.deviceSerial
    ? cell.name.replace(
        /Bluetooth|Cellular/gi,
        "..." + row.onBoarding.deviceSerial.slice(-8)
      )
    : cell.name;
  // Build image URL from your image field
  const imageUrl = cell.image ? `${process.env.REACT_APP_VIDEO_CALL_REQUEST + cell.image}` : null;

  return (
    <div className="device-side-by-side">
      {/* Device Image */}
      <div className="device-image-container">
        {imageUrl ? (
          <img
            src={imageUrl}
            alt={cell.name || 'Device'}
            className="device-image-side"
            onError={(e) => {
              // Hide image and show fallback on error
              e.target.style.display = 'none';
              e.target.nextSibling.style.display = 'flex';
            }}
            onLoad={(e) => {
              // Show image and hide fallback on load
              e.target.style.display = 'block';
              e.target.nextSibling.style.display = 'none';
            }}
          />
        ) : null}

        {/* Fallback icon when no image */}
        <div
          className="device-fallback-side"
          style={{
            display: imageUrl ? 'none' : 'flex'
          }}
        >
          <i className="mdi mdi-devices"></i>
        </div>
      </div>

      {/* Device Name - Your existing content */}
      <div className="device-name-container">
        <p className="device-name-side">{displayName}</p>
        

        {/* Optional: Add device description if available */}
        {cell.description && (
          <p className="device-desc-side">{cell.description}</p>
        )}
      </div>
    </div>
  );
}

function NoteColumn({ cell }) {
  const maxLength = 150;
  const [isExpanded, setIsExpanded] = useState(false);
  if(cell && cell.length > maxLength){
    const shortContent = cell.substring(0, maxLength);
    const contentToShow = isExpanded ? cell : shortContent;
    const toggleExpansion = () => {
      setIsExpanded(!isExpanded);
    };
    return (
      <div className="text-justify" style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', textAlign: 'center' }}>
        <p style={{ margin: 0 }}>{contentToShow}
        {!isExpanded && (
          <>
          ...
          <a onClick={toggleExpansion} className="btn-read-more">Read More</a>
          </>
        )}
        {isExpanded && (
            <>
              &nbsp;{/* Add some space */}
              <a onClick={toggleExpansion} className="btn-read-more">Read Less</a>
            </>
          )}
        </p>
      </div>
    );
  }else{
    return <div><p>{cell ? cell : " - "}</p></div>;
  }
}
function formatDate(cell) {
  return (<p>{moment(cell).format("MMMM DD, YYYY hh:mm:ss A")}</p>);
}
function deleteButton(cell, row, index, formatExtraData) {
  if (!row.isPublic) {
    return (
      <button
        type="button"
        className="btn btn-info ml-2 delete-note-click"
        onClick={() => {
          Swal.fire({
            title: 'Are you sure?',
            text: "You won't be able to revert this!",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Yes, delete it!'
          }).then((result) => {
            if (result.isConfirmed) {
              formatExtraData.delete(row._id)
            }
          })
        }}
      >
        <i class="mdi mdi-delete"></i> Delete
      </button>
    );
  } else {
    return (
      <div>
        <button
          type="button"
          className="btn btn-info ml-2 delete-note-click"
          onClick={() => {
            Swal.fire({
              title: 'Are you sure?',
              text: "You won't be able to revert this!",
              icon: 'warning',
              showCancelButton: true,
              confirmButtonColor: '#3085d6',
              cancelButtonColor: '#d33',
              confirmButtonText: 'Yes, delete it!'
            }).then((result) => {
              if (result.isConfirmed) {
                formatExtraData.delete(row._id)
              }
            })
          }}
        >
          <i class="mdi mdi-delete"></i> Delete
        </button>
      </div>
    );
  }
}
const rowComponent = (row) => {
  if (row.subject && row.subject.indexOf("Permission Request") > -1) {
    return (
      <div className="text-left">
        {row.body && <h4 className="message-display">{row.body}</h4>}
        <Link to="/sharing" className="btn btn-primary btn-sm">
          Approved Here
        </Link>
      </div>
    );
  }
  if (row.educationMaterial && row.educationMaterial.files && row.educationMaterial.files.length > 0) {
    return (<div>
      <div className="message-display">
        <div>
          <h5>Educational Material Files</h5>
          <div style={{ display: 'flex', flexWrap: 'wrap', gap: '10px' }}>
            {row.educationMaterial.files.map((file, index) => {
              const { icon, color } = getFileIconClass(file.name);
              return (
              <div
                key={index}
                className="d-flex align-items-center p-3 link-hover"
                style={{
                    display: 'flex',
                    alignItems: 'center',
                    padding: '5px 10px',
                    border: '1px solid #ddd',
                    borderRadius: '6px',
                    // maxWidth: '300px',
                    wordBreak: 'break-word',
                }}
              >
                <span className="pdf-icon me-2">
                 <i
                  className={icon}
                  style={{ fontSize: 20, color, marginRight: 6 }}
                  ></i>
                </span>
                <a
                  href={process.env.REACT_APP_VIDEO_CALL_REQUEST + "/" + file.path}
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{
                    color: "black",
                    fontWeight: 200,
                    overflowWrap: "anywhere",
                    transition: ' 0.3s ease'
                  }}
                >
                  {file.name}
                </a>
              </div>
            )})}
          </div>
        </div>

        {row.educationMaterial.materialLink && row.educationMaterial.materialLink.length > 0 && (
          <div style={{marginBottom : '2px'}}>
            <h5>Educational Material Links</h5>
            <div style={{ display: 'flex', flexWrap: 'wrap', gap: '10px' }}>
              {row.educationMaterial.materialLink.map((item, index) => (
                <div
                  key={index}
                  className="d-flex align-items-center p-3 link-hover"
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    padding: '5px 10px',
                    border: '1px solid #ddd',
                    borderRadius: '6px',
                    // maxWidth: '300px',
                    wordBreak: 'break-word',
                  }}
                >
                  <i
                    className="mdi mdi-link mr-2"
                    style={{ fontSize: 20, color: 'blue', marginRight: 6 }}
                  ></i>
                  <a
                    href={item}
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{
                      color: "black",
                      fontWeight: 200,
                      overflowWrap: "anywhere"
                    }}
                  >
                    {item}
                  </a>
                </div>
              ))}
            </div>
          </div>
        )}
      </div>
    </div>)
  } else {
    return <div className="text-left">{row.body && <div>
      <h4 className="message-display">{row.body}</h4>
    </div>}</div>;
  }
};

const NoteList = (props, context) => (
  <div className="scrollbar-table-cls">
  <BootstrapTable
    wrapperClasses="table-responsive"
    keyField="_id"
    noDataIndication={() => {
      return <div>
        {props.loading && (
          <LottieLoader
            loadLoop={true}
            autoplayLoop={true}
            source={lottieLoaderFile}
            Lheight={150}
            Lwidth={150}
            subTitle={"Please Wait ..."}
          />
        )}
        {!props.loading && (
          <LottieLoader
            loadLoop={true}
            autoplayLoop={true}
            source={lottieEmptyFile}
            Lheight={300}
            Lwidth={300}
            title={"Sorry! No note found :("}
            subTitle={"We can't find any note."}
          />
        )}
      </div>
    }}
    data={_.orderBy(props.notes, "createdAt", "desc")}
    expandRow={{
      renderer: (row) => rowComponent(row),
      showExpandColumn: true,
      onExpand: (row, isExpand, rowIndex, e) => {},
    }}
    filter={filterFactory()}
    filterPosition="top"
    columns={[
      {
        dataField: "subject",
        text: "Subject",
        sort: true,
        filter: textFilter({
          className: 'input-date-filter',
          placeholder:"Search by subject"
        }),
        headerStyle: (colum, colIndex) => {
          return { width: '15%', textAlign: 'left' };
        },
        formatter: (cell, row) => {
          const reminderDisplay = formatAppointmentReminderBadge(row.reminderNoteData);
          const isOverdue = isAppointmentOverdue(row.reminderNoteData);
          return (
            <>
              <p className="mb-1 font-weight-medium">{cell ? cell : '-'}</p>
              {reminderDisplay && (
                <div 
                  className="reminder-badge"
                  title={reminderDisplay.fullLabel}
                  style={{
                    display: 'inline-flex',
                    alignItems: 'center',
                    gap: '6px',
                    padding: '4px 10px',
                    borderRadius: '20px',
                    fontSize: '0.75rem',
                    fontWeight: 500,
                    backgroundColor: isOverdue ? '#ffebee' : '#fff3e0',
                    border: `1px solid ${isOverdue ? '#ef5350' : '#ffb74d'}`,
                    color: isOverdue ? '#c62828' : '#e65100',
                    marginTop: '-4px',
                    cursor: 'default',
                    transition: 'all 0.2s ease'
                  }}
                >
                  <i 
                    className={`mdi ${isOverdue ? 'mdi-bell-alert' : 'mdi-bell-outline'}`}
                    style={{ fontSize: '14px' }}
                  ></i>
                  <span>
                    {reminderDisplay.dateLabel} • {reminderDisplay.timeLabel}
                  </span>
                </div>
              )}
            </>
          );
        },
      },
      {
        dataField: "body",
        text: "Note",
        sort: true,
        formatter: (cell, row, index, formatExtraData) => (
          <NoteColumn cell={cell} />
        ),
        filter: textFilter({
          className: 'input-date-filter',
          placeholder:"Search by note"
        }),
        headerStyle: (colum, colIndex) => {
          return { width: '44%', textAlign: 'left' };
        }  
      },
      {
        dataField: "device",
        text: "Shipped Device",
        sort: true,
        formatter: device,  
        headerStyle: (colum, colIndex) => {
          return { width: '12%', textAlign: 'left' };
        }      
      },
      {
        dataField: "createdAt",
        text: "Created time",
        sort: true,
        formatter: formatDate,
        headerStyle: (colum, colIndex) => {
          return { width: '12%', textAlign: 'left' };
        },
      },
      {
        dataField: "createdBy.lname",
        text: "Noted By",
        sort: true,
        formatter: fullname,
        filter: textFilter({
          className: 'input-date-filter',
          placeholder:"Search by last name"
        }),
        headerStyle: (colum, colIndex) => {
          return { width: '12%', textAlign: 'left' };
        }
      },
      {
        dataField: "test",
        text: "Delete",
        sort: false,
        formatter: deleteButton,
        formatExtraData: {
          delete: props.deleteInbox
        },
        headerStyle: (colum, colIndex) => {
          return { width: '5%', textAlign: 'left' };
        }
      }
    ]}
  />
  </div>
);

export default NoteList;
